import UserMessagesInboxContactList from './user_messages_inbox_contact_list';
import UserMessagesInboxForm from './user_messages_inbox_form';
import UserMessagesInboxEntries from './user_messages_inbox_entries';

const FORM_SELECTOR = '[data-user-messages-inbox-form]';
const ENTRIES_SELECTOR = '[data-user-messages-inbox-entries]';
const CONTACT_LIST_SELECTOR = '[data-user-messages-contact-list]';

class UserMessagesInbox {
  constructor(container) {
    this.container = container;

    let contactList = this.container.querySelector(CONTACT_LIST_SELECTOR);
    if (contactList instanceof HTMLElement) {
      this.contactList = new UserMessagesInboxContactList(this.container);
    }

    let form = this.container.querySelector(FORM_SELECTOR);
    if (form instanceof HTMLFormElement) {
      this.form = new UserMessagesInboxForm(form);
    }

    let entries = this.container.querySelector(ENTRIES_SELECTOR);
    if (entries instanceof HTMLElement) {
      this.entries = new UserMessagesInboxEntries(entries);
    }

    if (this.entries && this.form) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.form.on('newentry', entry => {
      this.entries.add(entry);
    });
  }
}

export default UserMessagesInbox;



// WEBPACK FOOTER //
// ./src/javascripts/user_messages/user_messages_inbox.js